export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto des Anbieters auswählen"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto des Anbieters"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select Account"])}
}